import { useTheme } from '@/components/providers/theme-provider';
import Text from '@ingka/text';

export type IntroProps = {
  title: string;
  description: string;
  className?: string;
};

export const Intro = ({ title, description, className }: IntroProps) => {
  const { theme } = useTheme();
  return (
    <div className={`plann-content-page-intro ${className}`}>
      <Text
        tagName='h1'
        textStyle='Heading.L'
        style={{ marginBottom: '2' }}
        className={`${theme === 'light' ? '!text-black' : '!text-white'}`}
      >
        {title}
      </Text>
      <Text
        tagName='p'
        style={{ marginBottom: '4rem' }}
        className={`plann-content-page-intro__description max-w-3xl ${theme === 'light' ? '!text-black' : '!text-white'}`}
      >
        {description}
      </Text>
    </div>
  );
};
